import { AnyMenuItem, getLocaleSwitch, getNavBar, useLocale } from "@dgs/core";
import { FC, useCallback, useEffect } from "react";
import { useLocation } from "react-router";
import { useMenuQuery } from "./shared/api/menu";
import { useConfig } from "./shared/hooks/useConfig";
import { useNavigateWithQueryParams } from "./useNavigateWithQueryParams";

const NavBar = getNavBar();
const LocaleSwitch = getLocaleSwitch();

export const PMNavBar: FC = () => {
	const { languageSettings, productData } = useConfig();
	const { items, isLoading } = useMenuQuery();
	const location = useLocation();
	const navigate = useNavigateWithQueryParams();
	const { language, setLanguage } = useLocale();

	const handleNavigate = useCallback(
		(item: AnyMenuItem) => {
			if (item.type === "PAGE") {
				navigate(`blocks/${item.block.slug}`, { replace: true });
			} else if (item.type === "INTERNAL") {
				navigate(item.url, { replace: true });
			}
		},
		[navigate],
	);

	useEffect(() => {
		if (!isLoading && location.pathname === "/") {
			if (productData.startPageMenuItem) {
				handleNavigate(productData.startPageMenuItem);
			} else if (productData.defaultRegistrationFormId) {
				navigate(`registrations/${productData.defaultRegistrationFormId}`, { replace: true });
			} else if (items.length > 0) {
				handleNavigate(items.filter((i) => i.type === "INTERNAL" || i.type === "PAGE")[0]);
			}
		}
	}, [
		handleNavigate,
		isLoading,
		items,
		location.pathname,
		navigate,
		productData.defaultRegistrationFormId,
		productData.startPageMenuItem,
	]);

	return (
		<NavBar appIdentifier={productData.htmlTitle} items={items}>
			<LocaleSwitch setLocale={setLanguage} locale={language} availableLocales={languageSettings.availableLanguages} />
		</NavBar>
	);
};
